module.exports = __webpack_public_path__ + "media/preview.mp4";